/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: FieldIndicator.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/18 @ 195
 * ---
 * Description:
 */

import {Editor} from '../../../store/observables/Editor';
import {observer} from 'mobx-react';
import {Button, Icon, Intent} from '@blueprintjs/core';
import {dataRefNameOf} from '@revodigital/mpes/lib/components/data/DataRefNameFactory';
import {MleToaster} from '../../../common/toast';
import {Tooltip2} from '@blueprintjs/popover2';
import {RefData} from './OriginTypeSection';
import {NameValue} from "../../../common/utils";

interface Props {
    editor: Editor;
    refData: RefData;
}

export const FieldIndicator = observer((props: Props) => {

    const valueIsNotGiven = (value: any) => !value || value === 'null' || value === 'undefined';

    const FieldPreview = (props: NameValue) => {
        return (
            <div className="flex flex-col">
                <div>
                    <b>
                        Campo: </b>
                    {
                        props.name
                    }
                </div>
                {
                    valueIsNotGiven(props.value) ?
                        <div className="flex flex-row text-yellow-700"><Icon className="mr-2" icon="warning-sign"
                                                                             intent={Intent.WARNING}/> Campo non
                            valorizzato</div> :
                        <div>
                            <b>
                                Valore: </b>
                            {
                                `${props.value}`
                            }
                        </div>}
            </div>
        )
    }

    return (
        <div
            className="p-2 flex flex-row w-52 divide-solid justify-between cursor-default">
            <Tooltip2 className="w-3/4" content={
                <FieldPreview name={props.refData.ref.name} value={props.refData.value}/> ||
                <div className="flex flex-row space-x-2 w-3/4">
                    <Icon icon="warning-sign" size={20} intent={Intent.WARNING}/>
                    <div>Non valorizzato</div>
                </div>}>
                <div className="py-2 w-3/4 overflow-hidden truncate">{props.refData.ref.name.replace('data.', '')}</div>
            </Tooltip2>
            <div>
                <Button icon="duplicate" onClick={() => {
                    navigator.clipboard.writeText(dataRefNameOf(props.refData.ref.name));
                    MleToaster.getInstance().show({
                        message: 'Codice campo origine copiato',
                        intent: Intent.SUCCESS,
                        icon: 'duplicate'
                    });
                }} minimal/>
            </div>
        </div>
    );
});
